<template>
  <div style="height: 100%">
    <div style="display: flex; width: 100%">
      <div style="width: 90%; height: 40px">
        <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
          <el-input v-model="formDatas.sbcIp" style="width: 200px; margin-left: 10px;" size="mini" placeholder="请输入数据库地址" clearable></el-input>
          <el-input v-model="formDatas.dbName" style="width: 180px; margin-left: 10px;" size="mini" placeholder="请输入数据库名称" clearable></el-input>
          <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
            style="margin-left: 10px">搜索</el-button>
            <el-button type="success" size="mini" style="margin-right: 20px" @click="handleAction">执行备份</el-button>
        </el-row>
      </div>
      <div style="width: 10%; height: 40px">
        <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
          <el-button type="success" size="mini" style="margin-right: 20px" @click="BoxOpen">新增</el-button>
        </el-row>
      </div>
    </div>
    <div class="tablemain">
      <div class="tablecss">
        <div style="width: 100%">
          <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData" :max-height="tableHight"
            :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
            :checkbox-option="checkboxOption" row-key-field-name="sbcId" :cellSelectionOption="cellSelectionOption"
            style="width: 100%" />
            <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
        </div>
        <div class="table-pagination">
          <ve-pagination :total="totalCount" :page-index="formDatas.currentPage" :page-size="formDatas.pageSize"
            :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]" @on-page-number-change="pageNumberChange"
            @on-page-size-change="pageSizeChange" />
        </div>
      </div>
      <!-- 新增/编辑 -->
      <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑备份数据库' : '新增备份数据库'" :before-close="handleClose"
        :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
        <div class="demo-drawer__content" style="height: 90%;">
          <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
            <div style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
              <el-form-item label="数据库地址" prop="sbcIp">
               <el-input v-model="form.sbcIp" style="width: 80%;" placeholder="请输入数据库地址"></el-input>
              </el-form-item>
              <el-form-item label="数据库名称" prop="dbName">
                <el-input v-model="form.dbName" style="width: 80%;" placeholder="请输入数据库名称"></el-input>
              </el-form-item>
              <el-form-item label="数据库用户名" prop="dbUsername">
                <el-input v-model="form.dbUsername" style="width: 80%;" placeholder="请输入数据库用户名"></el-input>
              </el-form-item>
              <el-form-item label="数据库密码" prop="dbPassword">
                <el-input v-model="form.dbPassword" type="password" style="width: 80%;" placeholder="请输入数据库密码" show-password></el-input>
              </el-form-item>
              <el-form-item label="备注" prop="sbcRemark">
                <el-input type="textarea" v-model="form.sbcRemark" style="width: 80%;" placeholder="请输入备注"></el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="demo-drawer__footer" style="margin-top: 10px;">
          <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
          <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
            确 定</el-button>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import { getSysBackupConfigList, addSysBackupConfig, updateSysBackupConfig, deleteSysBackupConfig, addSysBackupConfigAction } from "../../api/api";
export default {
  name: "",
  components: {},
  data() {
    return {
      dialog: false,
      edit: false,
      form: {
        sbcIp: '',
        dbName: '',
        dbUsername: '',
        dbPassword: '',
        sbcRemark: '',
      },
      rules: {
        sbcIp: [{ required: true, message: '请输入数据库地址', trigger: 'blur' }],
        dbName: [{ required: true, message: '请输入数据库名称', trigger: 'blur' }],
        dbUsername: [{ required: true, message: '请输入数据库用户名', trigger: 'blur' }],
        dbPassword: [{ required: true, message: '请输入数据库密码', trigger: 'blur' }],
      },
      // 单元格编辑功能
      editOption: {
        beforeCellValueChange: ({ row, column, changeValue }) => {
          this.beforeCellValChange(row, column, changeValue);
        },
        afterCellValueChange: ({ row, column, changeValue }) => {
          this.afterCellValChange(row, column, changeValue);
        },
      },
      cellSelectionOption: {
        enable: true,
      },
      totalCount: 100,
      pageIndex: 1,
      pageSize: 20,
      selectedRowKeysCollection: [],
      checkboxOption: {
        selectedRowKeys: [],
        selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
          this.changeSelectedRowKeys(row, isSelected);
        },
        selectedAllChange: ({ isSelected, selectedRowKeys }) => {
          this.changeSelectAll(isSelected, selectedRowKeys);
        },
      },
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          if (rowIndex === 0) {
            return "table-header-cell-class";
          }
        },
      },
      windheight: "",
      tableHight: 520,
      columns: [
        {
          field: "",
          key: "a",
          title: "序号",
          width: 50,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return ++rowIndex;
          },
        },
        {
          field: "sbcIp",
          key: "sbcIp",
          title: "数据库地址",
          width: 200,
          align: "center",
        },
        {
          field: "dbName",
          key: "dbName",
          title: "数据库名称",
          width: 180,
          align: "center",
        },
        {
          field: "dbUsername",
          key: "dbUsername",
          title: "用户名",
          width: 150,
          align: "center",
        },
        {
          field: "sbcRemark",
          key: "sbcRemark",
          title: "备注",
          width: 200,
          align: "center",
        },
        { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
        {
          field: "",
          key: "d",
          title: "操作",
          width: 200,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                <el-button
                  size="mini"
                  type="text"
                  on-click={() => this.handleEdit(row)}
                >
                  编辑
                </el-button>
                <el-button
                  size="mini"
                  type="text"
                  style="color: red"
                  on-click={() => this.handleDelete(row)}
                >
                  删除
                </el-button>
              </span>
            );
          },
        },
      ], //表格的列
      tableData: [],
      formDatas: {
        sbcIp: "",
        dbName: "",
        currentPage: 1,
        pageSize: 20,
      },
    };
  },
  activated() {
    this.getList();
    this.watchFlag = true;
    this.$nextTick(() => {
      this.windheight = this.$store.state.windheight;
      this.tableHight = this.windheight - 200 - this.windheight * 0.04;
    });
  },
  watch: {
    "$store.state.windheight"(val) {
      this.$nextTick(() => {
        if (this.watchFlag) {
          this.tableHight = val - 200 - val * 0.04;
        }
      });
    },
  },
  deactivated() {
    this.watchFlag = false;
  },
  created() {
    this.windheight = this.$store.state.windheight
    this.tableHight =  this.windheight - 200 -  this.windheight * 0.04;
    this.getList();
  },
  mounted() { },
  methods: {
    // 执行备份
    handleAction() {
      this.$confirm("是否确定要执行备份吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          addSysBackupConfigAction().then(res => {
            if (res.data) {
              this.$message({
                type: "success",
                message: "备份执行成功!",
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        })
    },
    handleDelete(row) {
      this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteSysBackupConfig({ sbcId: row.sbcId }).then(res => {
            if (res.data) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.partserch()
            }
          })
        }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        })
    },
    handleEdit(row) {
      const data = JSON.parse(JSON.stringify(row))
      this.dialog = true;
      this.edit = true;
      this.$nextTick(() => {
        this.form = {
          sbcId: data.sbcId,
          sbcIp: data.sbcIp,
          dbName: data.dbName,
          dbUsername: data.dbUsername,
          dbPassword: data.dbPassword,
          sbcRemark: data.sbcRemark || '',
        }
      })
    },
    SureBtn() {
      if (!this.edit) {
        this.$confirm("是否确定要新增, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            addSysBackupConfig(this.form).then(res => {
              if (res.data) {
                this.$message({
                  type: "success",
                  message: "新增成功!",
                });
                this.handleClose()
                this.getList()
              }
            })
          }).catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          })
      } else {
        this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            updateSysBackupConfig(this.form).then(res => {
              if (res.data) {
                this.$message({
                  type: "success",
                  message: "编辑成功!",
                });
                this.handleClose()
                this.getList()
              }
            })
          }).catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          })
      }
    },
    BoxOpen() {
      this.dialog = true;
      this.edit = false;
      this.$nextTick(() => {
        this.$refs['formRef'].resetFields();
        this.form = {
          sbcIp: '',
          dbName: '',
          dbUsername: '',
          dbPassword: '',
          sbcRemark: '',
        }
      })
    },
    // 关闭弹框
    handleClose() {
      this.dialog = false;
      this.edit = false;
      this.$refs['formRef'].resetFields();
    },
    resetSelectedRowKeys() {
      this.checkboxOption.selectedRowKeys = [];
      const selectedRowKeysCollection = this.selectedRowKeysCollection;
      if (selectedRowKeysCollection.length) {
        this.tableData.forEach((item) => {
          if (selectedRowKeysCollection.indexOf(item.sbcId) > -1) {
            this.checkboxOption.selectedRowKeys.push(item.sbcId);
          }
        });
      }
    },
    changeSelectAll(isSelected, selectedRowKeys) {
      this.checkboxOption.selectedRowKeys = selectedRowKeys;
      if (isSelected) {
        this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
      } else {
        this.tableData.forEach((item, index) => {
          if (this.selectedRowKeysCollection.indexOf(item.sbcId) > -1) {
            this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item.sbcId), 1);
          }
        });
      }
    },
    changeSelectedRowKeys(row, isSelected) {
      const rowKey = row.sbcId;
      if (isSelected) {
        this.checkboxOption.selectedRowKeys.push(rowKey);
        this.selectedRowKeysCollection.push(rowKey);
      } else {
        const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
        this.checkboxOption.selectedRowKeys.splice(index, 1);
        this.selectedRowKeysCollection.splice(index, 1);
      }
    },
    pageSizeChange(pageSize) {
      this.formDatas.pageSize = pageSize;
      this.partserch();
    },
    pageNumberChange(pageIndex) {
      this.formDatas.currentPage = pageIndex;
      getSysBackupConfigList(this.formDatas).then((res) => {
        this.tableData = res.data;
        this.totalCount = res.total;
        this.resetSelectedRowKeys();
      });
    },
    partserch() {
      this.formDatas.currentPage = 1;
      getSysBackupConfigList(this.formDatas).then((res) => {
        this.tableData = res.data;
        this.totalCount = res.total;
        this.resetSelectedRowKeys();
      });
    },
    getList() {
      getSysBackupConfigList(this.formDatas).then((res) => {
        this.tableData = res.data;
        this.totalCount = res.total;
      });
    },
  },
};
</script>

<style>
.table-header-cell-class {
  background: var(--bg-color) !important;
  color: var(--font-color) !important;
  border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
  display: none;
}

.ve-table-container {
  height: auto !important;
}
</style>
